import PeerFeedback from './peer-feedback';

export default PeerFeedback;
